module.exports = "/assets/d5ced917974c811f13f21fb501804825.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/BD.png
// module id = 1226
// module chunks = 0